/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Subscription } from 'rxjs';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { UrlService } from 'src/app/services/util/url.service';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { Constants } from 'src/app/models/constants';
import { SystemService } from 'src/app/services/api/system.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { DeploymentClass } from 'src/app/models/instance-class';
import { AgentStatus } from 'src/app/models/agents/agent-status';
import { Instance } from 'src/app/models/instance/instance';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import {isSolutionVersion} from 'src/app/services/util/utils';
import { TenantOrigin } from 'src/app/models/tenant/tenant-status';
import { AVAILABLE_STATE_ICON } from 'src/app/models/instance/instance';
import { AvailabilityStatus } from 'src/app/models/availability-status';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.TENANT_READ,
    action: Permissions.TENANT_READ
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_NONPII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_PII,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.TENANT_ONBOARDING_DATAZONE_LIVE,
    action: Permissions.TENANT_ONBOARDING,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_NONPII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_NONPII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_START_DATAZONE_PII,
    action: Permissions.INSTANCE_START,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_STOP_DATAZONE_PII,
    action: Permissions.INSTANCE_STOP,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  }
];

@Component({
    selector: 'app-edge-network',
    templateUrl: './edge-network.component.html',
    styleUrls: ['./edge-network.component.scss'],
    standalone: false
})
export class EdgeNetworkComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild(MatSort, { static: true }) sort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  Constants = Constants;
  PermissionKeys = PermissionKeys;
  Permissions = Permissions;
  permissionsMap: { [key: string]: boolean };
  RouterSegments = RouterSegments;
  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];

  tenant: string;
  showSpinner: any;
  searchSolutionText: any;
  dropdownsList: any = [];
  dashboardLink: any;
  pageSize: number;
  pageNumber = 1;

  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  tenantList: any;
  tenantId: any;
  filteredColumns: any;
  clearData: boolean;
  selectedDefaultFilter: any;
  data: any;
  isLoading: boolean;
  copy = false;
  idCopy =  false;
  sharedInfraLink: any;
  showNosharedInfra: any;
  subscriptionIdPii: any;
  subscriptionNamePii: any;
  subDataZonePii: any;

  subscriptionIdNonPii: any;
  subscriptionNameNonPii: any;
  subDataZoneNonPii: any;

  subscriptionIdDDoS: any;
  subscriptionNameDDoS: any;
  subDataZoneDDoS: any;

  accountIdNonProdPii: any;
  accountNameNonProdPii: any;
  accountEmailNonProdPii: any;
  accDataZoneNonProdPii: any;
  accountIdNonPii: any;
  accountNameNonPii: any;
  accountEmailNonPii: any;
  accDataZoneNonPii: any;
  accountIdProdPii: any;
  accountNameProdPii: any;
  accountEmailProdPii: any;
  accDataZoneProdPii: any;
  DeployStatusPii: boolean;
  DeployStatusNonPii: boolean;
  DeployStatusNonProdPii: boolean;
  DeployStatusProdPii: boolean;
  piiData = [];
  nonPiiData = [];
  prodData = [];
  ddosData = [];
  DeployDDos: boolean;
  DeployIngressProd: boolean;
  DeployIngressNonPii: boolean;
  DeployIngressPii: boolean;
  DeployDDosStatus: any = {};
  ingressPii : any = [];
  ingressProd : any = [];
  ingressDDos = [{value: 'DDoS Protection - Primary' , response: 'primary', enabled: false, default: false, show: true, status: ''}, {value: 'DDoS Protection - Secondary' ,response: 'secondary', enabled: false, default: false, show: true, status: ''}];
  ingressNonPii : any = [];
  tenantDetailsData: any;
  accountData: any;
  isDataLoading: any;
  versions: any;
  azureTsiSolutionId: any;
  selectedValue: any;
  currentSolutionVersionId: string;
  currentVersion: any;
  solutionName: any;
  solutionSearchLoading = true;
  showCard: boolean;

  instanceClass = DeploymentClass;
  AgentStatus = AgentStatus;
  devInstance: any;
  testDataZoneInstances: any[];
  piiDataZoneInstances: any[];
  nonpiiStartStop: boolean;
  piiStartStop: boolean;
  solutionVersionSearch: any;
  awsTssSolutionId: any;
  azureTssSolutionId: any;
  instanceList: any;
  inprogressStatuses = [DeployStatus.REMOVING, DeployStatus.DEPLOYING, DeployStatus.INITIALIZING, DeployStatus.UPDATING, DeployStatus.CONFIGURING, DeployStatus.TESTING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.STARTING_AGENT, DeployStatus.STOPPING_AGENT, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];
  ddosStatusCompleted = [DeployStatus.ENABLED, DeployStatus.ENABLE_FAILED, DeployStatus.DISABLED, DeployStatus.DISABLE_FAILED];
  ddosStatus = [DeployStatus.ENABLING, DeployStatus.DISABLING];
  terminateDdos = [DeployStatus.ENABLE_FAILED, DeployStatus.DISABLE_FAILED];
  completedDdos = [DeployStatus.ENABLED, DeployStatus.DISABLED];
  errorStatus = [DeployStatus.REMOVING_FAILED, DeployStatus.FAILED, DeployStatus.INITIALIZE_FAILED, DeployStatus.UPDATE_FAILED, DeployStatus.CONFIGURATION_FAILED, DeployStatus.START_FAILED, DeployStatus.STOP_FAILED];
  terminateStatus = [DeployStatus.REMOVED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.TERMINATION_FAILED, DeployStatus.STOPPED];
  completedStatus = [DeployStatus.COMPLETED, DeployStatus.DEPLOYED, DeployStatus.INITIALIZED, DeployStatus.UPDATED, DeployStatus.CONFIGURED, DeployStatus.TESTED];
  searchValue: any;
  solutionVersions: any;
  solutionComponents :any = [];
  defaultComponents = [{value: 'Front Door' , response: 'public_loadbalancer', selected: false, default: false}, {value: 'Delinea PAM',response: 'delinea' , selected: false, default: false}];
  isLowerVersion : boolean;
  optionalComponentCount : number;
  isComponentLoading: boolean;
  AVAILABLE_STATE_ICON = AVAILABLE_STATE_ICON;
  instanceAvailabilityMap: { [id: string]: string } = {};
  AvailabilityStatus = AvailabilityStatus;
  showVersionWarning: boolean;

  readonly inprogressStatus = [DeployStatus.DEPLOYING, DeployStatus.TERMINATING, DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.TESTING,
     DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.OPERATION_INPROGRESS, DeployStatus.INPROGRESS];

  readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
  DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
  DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
  DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.INPROGRESS];

  readonly INSTANCE_DEPLOYING_STATUS_DDOS = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.TERMINATION_FAILED,
    DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING];
  ingressProdFalseCount: number;
  ingressDDosFalseCount: number;
  ingressPiiFalseCount: number;
  ingressNonProdFalseCount: number;
  ingressNonPiiFalseCount: number;
  enableDdosFeature = false;
  hasSecondaryRegion: boolean;

  constructor(private route: ActivatedRoute, private authService: AuthService, private instanceService: InstancesService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, private tenantService: TenantService,
    public dateTimeFormatService: DateTimeFormatService, private solutionsService: SolutionsService, private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private clipboardApi: ClipboardService,
    private urlService: UrlService, private router: Router, private permissionsService: PermissionsService, private systemService: SystemService) {

  }
  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'LEFT_SIDE_NAV.EDGE_NETWORK';
    this.tenant = this.authService.principal.provider;
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.TENANT_READ]) {
      this.router.navigate(['/', this.tenant, 'tenant', 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.DeployStatusNonPii = false;
    this.DeployStatusPii = false;
    this.DeployStatusNonProdPii = false;
    this.DeployStatusProdPii = false;
    this.tenantId = this.route.snapshot.params.id;
    if(this.tenantId) {
      this.isLoading = true;
      this.loadData(this.tenantId,true);
      this.loadInstances();
      this.enableDdosFeature = (this.authService.assignedFeaturePermissions?.find(item => item.name === 'ddos-protection').enabled === 'true' || this.authService.assignedFeaturePermissions?.find(item => item.name === 'ddos-protection').enabled === true) &&
        (this.authService.assignedFeaturePermissions?.find(item => item.name === 'ddos-protection').dataZones?.find(item => item.dataZone === 'prod').enabled === 'true' || this.authService.assignedFeaturePermissions?.find(item => item.name === 'ddos-protection').dataZones?.find(item => item.dataZone === 'prod').enabled === true);
      if (this.enableDdosFeature) {
        this.loadDDos();
      }
    }
    this.dashboardLink = ({ label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING') });
    this.sharedInfraLink = ({ label: translate('LEFT_SIDE_NAV.EDGE_NETWORK'), url: ['edge-network'] });
    this.dropdownsList = [
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_LIST.SELECT_TENANT'),
        key: 'tenant',
        options: []
      },
    ];
    // this.versions = ['1.0.1', '1.0.2'];
    this.clearData = true;
    this.tenant = this.authService.principal.provider;
    this.getTenants();
    this.showNosharedInfra = true;
  }

  getAvailabilityState(instanceId: string): string {
    return this.instanceAvailabilityMap?.[instanceId];
  }

  isDeployDisabled(instanceId: string): boolean {
    const availabilityState = this.getAvailabilityState(instanceId) as AvailabilityStatus;
    return [
      AvailabilityStatus.STARTING,
      AvailabilityStatus.STOPPING,
      AvailabilityStatus.STOPPED
    ].includes(availabilityState);
  }

  /**
   * Getting a tenant List to be displayed in filter removing all the external tenants.
   */
  getTenants(): void {
    this.dropdownsList[0].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data) {
          data = data.filter(value => value.managementType !== 'external' && value.tenantId !== 'temenos.com');
          this.tenantList = [...new Set(data.map(item => item.tenantId).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
          this.tenantList.forEach((value) => {
            this.dropdownsList[0].options.push({ value, selected: false });
          });
        }
      });
  }
  loadData(tenantId,initialLoad : boolean): void {
    if (initialLoad) {
    this.subscriptionIdPii = '';
    this.subscriptionIdNonPii = '';
    this.subscriptionIdDDoS = '';
    this.accountIdNonPii = '';
    this.accountIdNonProdPii = '';
    this.accountIdProdPii = '';
    }
    this.isDataLoading = initialLoad;
    this.tenantService.getTenantDetails(tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetailsData = data;
      if(this.tenantDetailsData?.parameters?.hasSecondaryRegion && (this.tenantDetailsData?.parameters?.hasSecondaryRegion === 'true' || this.tenantDetailsData?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if(!this.tenantDetailsData?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
        if(!this.hasSecondaryRegion) {
        this.ingressDDos.find(i => i.response === 'secondary').show = false;
      }
      if(this.tenantDetailsData?.parameters?.instanceStopStart?.length > 0) {
        this.tenantDetailsData?.parameters?.instanceStopStart.forEach(data => {
          if(data === 'nonpii') {
            this.nonpiiStartStop = true;
          }
          if(data === 'pii') {
            this.piiStartStop = true;
          }
        })
      }
      this.systemService.getSystem().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
           if(response.azureTsiSolutionId) {
          this.azureTsiSolutionId = response.azureTsiSolutionId;
          this.solutionsService.getSolutionById(response.azureTsiSolutionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
            this.solutionName = data.name;
          })
          this.solutionsService.getSolutionVersions(response.azureTsiSolutionId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
            if(data) {
              this.versions = [];
              // this.solutionName = data[0].name;
                this.prepareComponents(data);

              const serviceObj = this.tenantDetailsData?.sharedInfra ? Object.keys(this.tenantDetailsData?.sharedInfra) : undefined;
              const isAllCompleted = serviceObj?.every((key: string) => this.tenantDetailsData?.sharedInfra[key]?.status === 'completed');
              this.isComponentLoading = isAllCompleted ? false : true;
              if(serviceObj?.length) {
                serviceObj.forEach(item => {
                  const availableService = this.tenantDetailsData?.sharedInfra?.[item];
                  if (availableService && availableService?.instanceId) {
                    this.instanceService.getInstanceById(this.tenantDetailsData?.sharedInfra?.[item]?.instanceId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(instanceData => {
                      this.tenantDetailsData.sharedInfra[item].instanceDetails = instanceData;
                      this.currentSolutionVersionId = instanceData.solutionVersionId;
                      data.forEach((value) => {
                        if(value.id === this.currentSolutionVersionId) {
                          this.currentVersion = value.version;
                          this.modifyComponents(this.currentVersion);
                          this.applyTenantOptionalComponents();
                          this.isComponentLoading = false;
                          if(this.currentVersion.split('.')[0] === '1' || this.selectedValue?.split('.')[0] === '0') {
                            this.showCard = true;
                          } else {
                            this.showCard = false;
                          }
                          this.solutionSearchLoading = true;
                        } else {
                          this.solutionSearchLoading = false;
                          this.versions.push(value.version);
                          this.solutionVersions = this.versions;
                        }
                      });
                    });

                  } else {
                    data.forEach((value) => {
                      this.solutionSearchLoading = false;
                      this.versions.push(value.version);
                    });
                  }
                });
              } else {
                data.forEach((value) => {
                  this.solutionSearchLoading = false;
                  this.versions.push(value.version);
                  this.solutionVersions = this.versions;
                });
              }
              this.isComponentLoading = false;
            }
          });
        }
      });
      if (this.tenantDetailsData?.sharedInfra?.prod?.publicLoadBalancerUrl && this.tenantDetailsData?.sharedInfra?.prod?.publicLoadBalancerUrl?.startsWith('https://')) {
        this.tenantDetailsData.sharedInfra.prod.publicLoadBalancerUrl = this.tenantDetailsData?.sharedInfra?.prod?.publicLoadBalancerUrl;
      } else if(this.tenantDetailsData?.sharedInfra?.prod?.publicLoadBalancerUrl){
        this.tenantDetailsData.sharedInfra.prod.publicLoadBalancerUrl = 'https://'+ this.tenantDetailsData?.sharedInfra?.prod?.publicLoadBalancerUrl;
      }
      if (this.tenantDetailsData?.sharedInfra?.nonprod?.publicLoadBalancerUrl && this.tenantDetailsData?.sharedInfra?.nonprod?.publicLoadBalancerUrl?.startsWith('https://')) {
        this.tenantDetailsData.sharedInfra.nonprod.publicLoadBalancerUrl = this.tenantDetailsData?.sharedInfra?.nonprod?.publicLoadBalancerUrl;
      } else if(this.tenantDetailsData?.sharedInfra?.nonprod?.publicLoadBalancerUrl){
        this.tenantDetailsData.sharedInfra.nonprod.publicLoadBalancerUrl = 'https://'+ this.tenantDetailsData?.sharedInfra?.nonprod?.publicLoadBalancerUrl;
      }
      this.isDataLoading = false;

      if (data?.cloudProvider === 'AWS' || data?.targetCloud === 'AWS') {
        if (this.tenantDetailsData?.sharedInfra?.pii?.status === DeployStatus.SUCCESS) {
          this.tenantDetailsData.sharedInfra.pii.instanceDetails = this.tenantDetailsData.sharedInfra.pii.instanceDetails || {};
          this.tenantDetailsData.sharedInfra.pii.instanceDetails.status = DeployStatus.DEPLOYED;
          this.DeployIngressPii = true;
        }
        if (this.tenantDetailsData?.sharedInfra?.prod?.status === DeployStatus.SUCCESS) {
          this.tenantDetailsData.sharedInfra.prod.instanceDetails = this.tenantDetailsData.sharedInfra.prod.instanceDetails || {};
          this.tenantDetailsData.sharedInfra.prod.instanceDetails.status = DeployStatus.DEPLOYED;
          this.DeployIngressProd = true;
        }
      }
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
    this.tenantService.getTenantAccountDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.accountData = data;
          this.accountData?.forEach(item => {
            if(item?.azureDetails) {
              if(item?.dataZone === SubscriptionTypes.PII) {
                this.subscriptionIdPii = item?.azureDetails?.subscriptionId;
              } else {
                this.subscriptionIdNonPii = item?.azureDetails?.subscriptionId;
                this.subscriptionIdDDoS = item?.azureDetails?.subscriptionId;
              }
            }
            if(item?.awsDetails) {
              if(item?.dataZone === SubscriptionTypes.NONPII) {
                this.accountIdNonPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.AWS_NON_PROD_PII){
                this.accountIdNonProdPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.AWS_PROD_PII){
                this.accountIdProdPii = item?.awsDetails?.accountId;
              }
            }
          });
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    }


  loadInstances(): void {
    const obj = {
      tenantId: this.tenantId
    };
    this.instanceService.getInstances(obj)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
        if (data?.total > 10) {
          const instanceObj = {
            size: data.total,
            tenantId: this.tenantId
          };
          this.instanceService.getInstances(instanceObj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(instances => {
              this.instanceList = instances.data;
              this.instanceAvailabilityMap = {};
              this.instanceList.forEach(instance => {
                this.instanceAvailabilityMap[instance.id] =
                  instance.availabilityState;
              });
          });
        } else {
          this.instanceList = data.data;
          this.instanceAvailabilityMap = {};
          this.instanceList.forEach(instance => {
            this.instanceAvailabilityMap[instance.id] =
              instance.availabilityState;
          });
          const liveA = this.findLiveAInstance();
          this.DeployDDos = liveA ? true : false;
          this.DeployDDosStatus = liveA;
        }
      }, (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }


  loadDDos(): void {
    this.tenantService.getDdosProtection(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response) => {
          if (response?.prod) {
            this.ingressDDos.find(i => i.response === 'primary').enabled = response.prod.enabled === true || response.prod.enabled === 'true';
            this.ingressDDos.find(i => i.response === 'secondary').enabled = response.prod.secondary?.enabled === true || response.prod.secondary?.enabled === 'true';
            this.ingressDDos.find(i => i.response === 'primary').status = response?.prod?.status;
            this.ingressDDos.find(i => i.response === 'secondary').status = response?.prod?.secondary?.status;
          }
        },
        error: (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        }
      });
  }

  selectionChanged(value): void {
    this.modifyComponents(value);
    this.selectedValue = value;
    if(this.selectedValue.split('.')[0] === '1' || this.selectedValue.split('.')[0] === '0') {
      this.showCard = true;
    } else {
      this.showCard = false;
    }
  }

  onCopyId(data, field?): void {
    if (field === 'id') {
      this.idCopy = true;
    } else {
      this.copy = true;
    }
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.idCopy = false;
      this.copy = false;
    }, 2000);
  }

  selectOptionsIngressPii(data): void {
    this.ingressPii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const pii = this.piiData.indexOf(data);
          if (pii > -1) {
            this.piiData.splice(pii, 1);
          }
        } else {
          item.selected = true;
          this.piiData.push(item.value);
        }
      }
    });
  }

  selectOptionsIngressNonPii(data): void {
    this.ingressNonPii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const nonPii = this.nonPiiData.indexOf(data);
          if (nonPii > -1) {
            this.nonPiiData.splice(nonPii, 1);
          }
        } else {
          item.selected = true;
          this.nonPiiData.push(item.value);
        }
      }
    });
  }

  selectOptionsIngressProd(data): void {
    this.ingressProd.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const pii = this.prodData.indexOf(data);
          if (pii > -1) {
            this.prodData.splice(pii, 1);
          }
        } else {
          item.selected = true;
          this.prodData.push(item.value);
        }
      }
    });
  }

  selectOptionsIngressDDos(data): void {
    this.ingressDDos.filter((item) => {
      if (item.value === data) {
        if(item.enabled) {
          item.enabled = false;
          const ddos = this.ddosData.indexOf(data);
          if (ddos > -1) {
            this.ddosData.splice(ddos, 1);
          }
        } else {
          item.enabled = true;
          this.ddosData.push(item.value);
        }
      }
    });
  }

   /**
   * On clicking Deploy button, shared infra will get deployed in the specific environment.
   * @params - Environment value to be deployed.
   */
onClickDeployStatus(value): void {
    if(!this.hasSecondaryRegion && value === SubscriptionTypes.PROD && (this.tenantDetailsData?.sharedInfra?.prod?.status != DeployStatus.SUCCESS || this.tenantDetailsData?.sharedInfra?.prod?.status != DeployStatus.COMPLETED)) {
      this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        confirmButtonText: translate('TENANT_FORM.CONFIRM_BUTTON_REGION'),
        secondaryRegionWarn: true,
        secondaryMsg: true
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
          this.confirmCall(value);
        }
      })
    } else {
      this.confirmCall(value);
    }
  }

  confirmCall(value): void {
      const text = value === SubscriptionTypes.PII ? 'PII' : value === SubscriptionTypes.NON_PII ? 'Non PII' :
        value === SubscriptionTypes.NON_PROD ? 'Non PROD' : value === SubscriptionTypes.PROD ? 'PROD' :  value === SubscriptionTypes.DDoS ? 'DDoS' :'';
      const message = translate('TENANT_DETAILS.EDGE_MESSAGE') + text + '.';
      const DDosMessage = translate('TENANT_DETAILS.DDos_MESSAGE');
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TENANT_DETAILS.EDGE_TITLE'),
          message: value === SubscriptionTypes.DDoS ? DDosMessage : message,
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            if (this.tenantDetailsData?.cloudProvider === 'AWS' || this.tenantDetailsData?.targetCloud === 'AWS') {
              if (value === SubscriptionTypes.PII) {
                let PiiData: any;
                const component = [];
                this.ingressNonPii.forEach(element => {
                  if (element.selected === true || (!this.isLowerVersion && element.default === true)) {
                    component.push(element.response);
                  }
                });
                if (this.showCard) {
                  PiiData = {
                    tenantId: this.tenantId,
                    dataZone: 'pii',
                    components: component
                  };
                } else {
                  PiiData = {
                    tenantId: this.tenantId,
                    dataZone: 'pii',
                  };
                }
                this.tenantService.postTenantSharedInfraDetails(PiiData)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(pii => {
                    this.isComponentLoading = true;
                    this.loadData(this.tenantId,false);
                    setTimeout(() => {
                      const title = translate('TENANT_DETAILS.TENANT_PII_ENETWORK');
                      const message = translate('VIEW_WORKFLOW.EDGE_NETWORK_DEPLOYED');
                      this.toastrService.successMessage(message, title);
                    }, 500);
                    this.loadInstances();
                  },
                    (error) => {
                      const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
                      this.dialog.open(ErrorDialogComponent, {
                        minHeight: '342px',
                        width: '630px',
                        panelClass: 'flex-dialog',
                        data: {
                          title: translate('ERROR_DIALOG.EDGE_NON_PROD_FAILED'),
                          description: errorMessage
                        }
                      })
                    });

              } else if (value === SubscriptionTypes.PROD) {
                const component = [];
                this.ingressProd.forEach(element => {
                  if (element.selected === true || (!this.isLowerVersion && element.default === true)) {
                    component.push(element.response);
                  }
                });
                let prodData: any;
                if (this.showCard) {
                  prodData = {
                    tenantId: this.tenantId,
                    dataZone: 'prod',
                    components: component
                  };
                } else {
                  prodData = {
                    tenantId: this.tenantId,
                    dataZone: 'prod',
                  };
                }
                this.tenantService.postTenantSharedInfraDetails(prodData)
                  .pipe(takeUntilDestroyed(this.destroyRef))
                  .subscribe(pii => {
                    this.isComponentLoading = true;
                    this.loadData(this.tenantId,false);
                    setTimeout(() => {
                      const title = translate('TENANT_DETAILS.TENANT_PROD_ENETWORK');
                      const message = translate('VIEW_WORKFLOW.EDGE_NETWORK_DEPLOYED');
                      this.toastrService.successMessage(message, title);
                    }, 500);
                    this.loadInstances();
                  },
                    (error) => {
                      const errorMessage = typeof error === 'string' ? error : typeof error?.error === 'string' ? error.error : error;
                      this.dialog.open(ErrorDialogComponent, {
                        minHeight: '342px',
                        width: '630px',
                        panelClass: 'flex-dialog',
                        data: {
                          title: translate('ERROR_DIALOG.EDGE_PROD_FAILED'),
                          description: errorMessage
                        }
                      })
                    });
              }
          } else {
          if(value === SubscriptionTypes.PROD) {
          this.DeployIngressProd = true;
          const component  = [];
          this.ingressProd.forEach(element => {
           if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
            component.push(element.response);
           }
          });
          let prodData: any;
          if(this.showCard) {
            prodData = {
              tenantId : this.tenantId,
              prod: true,
              version: this.selectedValue ? this.selectedValue : this.currentVersion,
              components: component
          };
          } else {
            const component  = [];
            this.ingressProd.forEach(element => {
            if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
              component.push(element.response);
            }
            });
            prodData = {
              tenantId : this.tenantId,
              dataZone: 'prod',
              version: this.selectedValue ? this.selectedValue : this.currentVersion,
              components: component
          };
          }
          this.tenantService.postTenantSharedInfraDetails(prodData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(pii => {
              this.DeployIngressProd = false;
              this.isComponentLoading = true;
              this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.TENANT_PROD_ENETWORK');
              const message = translate('VIEW_WORKFLOW.EDGE_NETWORK_DEPLOYED');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
            },
            (error) => {
               const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.EDGE_PROD_FAILED'),
            description: errorMessage
          }}).afterClosed().subscribe(() => {this.DeployIngressProd = false;})
            });
          } else if(value === SubscriptionTypes.PII) {
            this.DeployIngressPii = true;
            const component  = [];
            this.ingressPii.forEach(element => {
             if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
              component.push(element.response);
             }
            });
            let piiData: any;
            if(this.showCard) {
              piiData = {
                tenantId : this.tenantId,
                prod: true,
                version: this.selectedValue ? this.selectedValue : this.currentVersion,
                components: component
            };
            } else {
              const component  = [];
              this.ingressPii.forEach(element => {
              if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
                component.push(element.response);
              }
              });
              piiData = {
                tenantId : this.tenantId,
                dataZone: 'pii',
                version: this.selectedValue ? this.selectedValue : this.currentVersion,
                components: component
            };
            }
            this.tenantService.postTenantSharedInfraDetails(piiData)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(pii => {
                this.DeployIngressPii = false;
                this.isComponentLoading = true;
                this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.TENANT_PII_ENETWORK');
              const message = translate('VIEW_WORKFLOW.EDGE_NETWORK_DEPLOYED');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
              },
              (error) => {
                 const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.EDGE_PII_FAILED'),
            description: errorMessage
          }}).afterClosed().subscribe(() => {this.DeployIngressPii = false;})
              });
            } else if(value === SubscriptionTypes.DDoS) {
            const primary = this.ingressDDos.find(i => i.response === 'primary')?.enabled || false;
            const secondary = this.ingressDDos.find(i => i.response === 'secondary')?.enabled || false;
            const ddosData = {
              tenantId: this.tenantId,
              prod: {
                enabled: primary,
                secondary: {
                  enabled: secondary
                }
              }
            };
            this.tenantService.putDdosProtection(ddosData)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe({
                next: (response) => {
                  this.loadDDos();
                },
                error: (error) => {
                  // Handle error
                  const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                  this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.DDOS_PROTECTION_FAILED'),
                      description: errorMessage
                    }
                  });

                },
                complete: () => {
                  // Optional: handle completion
                }
              });

            }else {
            const dataZone = value === SubscriptionTypes.NON_PROD ? 'nonprod' : value === SubscriptionTypes.NON_PII ? 'nonpii' :
              value === SubscriptionTypes.PII ? 'pii' : '';
            if (value === SubscriptionTypes.NON_PROD || value === SubscriptionTypes.NON_PII) {
              this.DeployIngressNonPii = true;
            }
            let nonPiiData: any;
            const component  = [];
            this.ingressNonPii.forEach(element => {
            if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
              component.push(element.response);
            }
            });
            if(this.showCard) {
              nonPiiData = {
                tenantId : this.tenantId,
                nonprod: true,
                version: this.selectedValue ? this.selectedValue : this.currentVersion,
                components: component
              };
            } else {
              const component  = [];
              this.ingressNonPii.forEach(element => {
              if(element.selected === true || (!this.isLowerVersion && element.default === true)) {
                component.push(element.response);
              }
              });
              nonPiiData = {
                tenantId : this.tenantId,
                dataZone,
                version: this.selectedValue ? this.selectedValue : this.currentVersion,
                components: component
              };
            }
          this.tenantService.postTenantSharedInfraDetails(nonPiiData)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(pii => {
              this.DeployIngressNonPii = false;
              this.isComponentLoading = true;
              this.loadData(this.tenantId,false);
            setTimeout(() => {
              const title = translate('TENANT_DETAILS.TENANT_EDGE_NETWORK');
              const message = translate('VIEW_WORKFLOW.EDGE_NETWORK_DEPLOYED');
              this.toastrService.successMessage(message, title);
            }, 500);
            this.loadInstances();
            },
            (error) => {
               const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.EDGE_NON_PROD_FAILED'),
            description: errorMessage
          }}).afterClosed().subscribe(() => {this.DeployIngressNonPii = false;})
            });
          }
        }
        }
      });
  }

  reDeploy(data): void {
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.EDGE_TITLE'),
        message: translate('VERSIONS.REDEPLOY_SUBTITLE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.instanceService.redeployInstance(data?.instanceId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((instanceData: any) => {
              data.instanceDetails = instanceData;
              data.status = instanceData.status;
               this.loadData(this.tenantId, false);
            },(error)=>{
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
              this.dialog.open(ErrorDialogComponent, {
                    minHeight: '342px',
                    width: '630px',
                    panelClass: 'flex-dialog',
                    data: {
                      title: translate('ERROR_DIALOG.REDEPLOY_FAILED'),
                      description: errorMessage
                    }
              });
            }
          );
        }
      });
  }

  closeMenu(data): void {
    this.clearData = false;
    this.sidenavService.searchFilter.next(data);
  }

  private startStopConfig(instance, event): void {
    event.stopPropagation();
  }

  validateInstances(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.changeInstanceStatus(instance, key);
    } else if (this.instanceList?.length !== 0) {
      if (key === 'nonpii' || 'nonprod') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.DEVELOPMENT);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog(key === 'nonpii' ? 'TENANT_DETAILS.INSTANCES_EDGENW_NONPII' : 'TENANT_DETAILS.INSTANCES_EDGENW_NONPROD');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      } else if (key === 'pii') {
        const instancesToCheck = this.instanceList?.filter(item => item.dataZone === DataZone.SECURE);
        if (instancesToCheck.some(item => item.status !== DeployStatus.STOPPED)) {
          this.openErrorDialog('TENANT_DETAILS.INSTANCES_EDGENW_PII');
        } else {
          this.changeInstanceStatus(instance, key);
        }
      }
    } else {
      this.changeInstanceStatus(instance, key);
    }
  }

  openErrorDialog(description): void {
    this.dialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '630px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('BLUEPRINT_SUMMARY.VALIDATION_ERROR'),
        description: translate(description)
      }
    });
  }

  changeInstanceStatus(instance?: Instance, key?: string): void {
    if (instance?.status === DeployStatus.STOPPED || instance?.status === DeployStatus.START_FAILED) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_START_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_START_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStart(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetailsData.sharedInfra[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_START_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '566px',
                  panelClass: 'flex-dialog',
                  data: {
                    title: translate('ERROR_DIALOG.INSTANCE_START_FAILED'),
                    description: errorMessage,
                  }
               })
              });
          }
      });
    }

    else {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('INSTANCE_DETAILS.INSTANCE_STOP_TITLE'),
          message: translate('INSTANCE_DETAILS.INSTANCE_STOP_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            this.instanceService.instanceStop(instance)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(data => {
                this.tenantDetailsData.sharedInfra[key].instanceDetails = data;
            setTimeout(() => {
              const title = translate('INSTANCE_DETAILS.INSTANCE');
              const message = translate('INSTANCE_DETAILS.INSTANCE_STOP_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              (error) => {
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title: translate('ERROR_DIALOG.INSTANCE_STOP_FAILED'),
                description: errorMessage
              }
            });
                });
          }
      });
    }
  }

  displayInstanceStatus(agentStatus?: any): string {
    if (agentStatus === DeployStatus.STOPPED || agentStatus === DeployStatus.START_FAILED || agentStatus === DeployStatus.STOPPING) {
      return 'Start';
    } else {
      return 'Stop';
    }
  }

  isInprogressStatus(status): any {
    return this.INSTANCE_DEPLOYING_STATES.includes(status);
  }

  accessInstanceMenu(instance): any {
    return (instance?.status !== DeployStatus.FAILED && instance?.status !== DeployStatus.TERMINATED && instance?.instanceClass !== this.instanceClass.A);
  }


  navigateToSolution(id): void {
    localStorage.setItem('tenantViewSolutionName', this.solutionName);
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId,RouterSegments.SOLUTION, id, 'versions']);
  }

  instanceIdClick(instance) {
    if (instance?.id) {
      this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.SERVICE_DEFINITION';
      this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.BLUEPRINTS, instance.blueprintId, RouterSegments.ENVIRONMENT, instance.id]);
    }
  }

  viewDetailsClick(dataZone): void {
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenantId, RouterSegments.EDGE_NETWORK, dataZone]);
  }

  searchChanged(value): void {
    this.solutionVersions = this.versions.filter(item => item?.toLowerCase().startsWith(value.toLowerCase()));
  }
  /**
 * Clear search text and reset options when dropdown closes
 */
  resetDropdown() {
    this.searchValue = '';
    this.solutionVersions = [...this.versions];
  }

  /**
   * Finds the first instance with dataZone 'live' and deploymentClass 'A' using reduce.
   */
  findLiveAInstance(): Instance | undefined {
    if (!this.instanceList || !Array.isArray(this.instanceList)) return undefined;
    return this.instanceList.reduce((found, curr) => {
      if (found) return found;
      if (curr.dataZone === DataZone.LIVE && curr.deploymentClass === DeploymentClass.A) {
        if(!this.INSTANCE_DEPLOYING_STATUS_DDOS.includes(curr.status)) {
          return curr;
        }
      }
      return undefined;
    }, undefined);
  }

  /**
   * Prepares solution capabilities mappings for each version.
   * @param data
   */
  prepareComponents(data:any) {
    const isIntegrationTenant = this.tenantDetailsData?.origin === TenantOrigin.EXTERNAL;
    data.forEach( (value : any) => {
      let components: any = [];
      let optionalCompCount = 0;
      // Sort mandatory first
      const sortedCapabilities = [...value.capabilities].sort( (a: any, b: any) => {
        if (a.required === "mandatory" && b.required !== "mandatory") {return -1;}
        if (a.required !== "mandatory" && b.required === "mandatory") { return 1;}
        return 0;
      });
      sortedCapabilities.forEach((item:any) => {
        const isMandatory = item.required === "mandatory";
        const isSystem = item.required === "system";
        if (isIntegrationTenant) {
          if (item.name === 'tenant-firewall') {
            components.push({
              value: item.displayName,
              response: item.name,
              selected: false,
              default: true,
            });
          }
          return;
        }
        if (!isMandatory && !isSystem) { optionalCompCount++;}
        if(!isSystem){
        components.push({
          value: item.displayName,
          response: item.name,
          selected: false,
          default: isMandatory, // Mandatory components are enabled by default
        });
      }
      });
      this.solutionComponents.push({ version: value.version, component: components, optionalCompCount: optionalCompCount });
    })
  }

  /**
   * Updates ingress component lists based on selected solution version.
   * @param version
   */
  modifyComponents(version:any) {
    this.showVersionWarning = false;
    if(isSolutionVersion(version) && version !== "") {
      // Load version-specific components
      this.isLowerVersion = false;
      const matchedVersion = this.solutionComponents.find( (item: any) => item.version === version);
      if (matchedVersion) {
        this.ingressPii = matchedVersion.component.map(comp => ({ ...comp }));
        this.ingressProd = matchedVersion.component.map(comp => ({ ...comp }));
        this.ingressNonPii = matchedVersion.component.map(comp => ({ ...comp}));
        this.optionalComponentCount = matchedVersion.optionalCompCount;
      }
    } else {
      // Load default components for lower versions
      this.isLowerVersion = true;
      const isIntegrationTenant = this.tenantDetailsData?.origin === TenantOrigin.EXTERNAL;
      if (isIntegrationTenant) {
        this.ingressPii = [];
        this.ingressProd = [];
        this.ingressNonPii = [];
        this.showVersionWarning = true;
        // const matchedVersion = this.solutionComponents.find((item: any) => item.version === version);
        // const baseComponents = matchedVersion?.component ?? [{ value: translate('TENANT_FIREWALL.TITLE'), response: 'tenant-firewall', selected: false, default: true }];
        // this.ingressPii = baseComponents.map((comp: any) => ({ ...comp }));
        // this.ingressProd = baseComponents.map((comp: any) => ({ ...comp }));
        // this.ingressNonPii = baseComponents.map((comp: any) => ({ ...comp }));
      } else {
        this.ingressPii = this.defaultComponents.map(comp => ({ ...comp }));
        this.ingressProd = this.defaultComponents.map(comp => ({ ...comp }));
        this.ingressNonPii = this.defaultComponents.map(comp => ({ ...comp }));
      }
    }
  }
  /**
   * Updates ingress components using tenant optional component data.
   */
  applyTenantOptionalComponents() {
    //PROD
    if (this.tenantDetailsData?.sharedInfra?.prod?.optionalComponents?.length > 0){
      this.ingressProd?.filter((item) => {
        this.tenantDetailsData?.sharedInfra?.prod?.optionalComponents.filter((component) => {
          if(item.response === component ) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.ingressProdFalseCount = this.ingressProd.filter(item => item.default === false).length;
    }
    //PII
    if (this.tenantDetailsData?.sharedInfra?.pii?.optionalComponents?.length > 0){
      this.ingressPii?.filter((item) => {
        this.tenantDetailsData?.sharedInfra?.pii?.optionalComponents.filter((component) => {
          if(item.response === component ) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.ingressPiiFalseCount = this.ingressPii.filter(item => item.default === false).length;
    }
    //NONPROD
    if (this.tenantDetailsData?.sharedInfra?.nonprod?.optionalComponents?.length > 0){
      this.ingressNonPii?.filter((item) => {
        this.tenantDetailsData?.sharedInfra?.nonprod?.optionalComponents.filter((component) => {
          if(item.response === component ) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.ingressNonProdFalseCount = this.ingressNonPii.filter(item => item.default === false).length;
    }
    //NONPII
    if (this.tenantDetailsData?.sharedInfra?.nonpii?.optionalComponents?.length > 0){
      this.ingressNonPii?.filter((item) => {
        this.tenantDetailsData?.sharedInfra?.nonpii?.optionalComponents.filter((component) => {
          if(item.response === component ) {
            item.default = true;
            item.selected = false;
          }
        });
      });
      this.ingressNonPiiFalseCount = this.ingressNonPii.filter(item => item.default === false).length;
    }
  }

}
